// extracted by mini-css-extract-plugin
export default {"tableTabs":"stylesTableTabs_tableTabs__KFtrx","sideTab":"stylesTableTabs_sideTab__X2bAb","tableTab":"stylesTableTabs_tableTab__br6fR","active":"stylesTableTabs_active__V67Uy"};